import EmptyData from 'components/common/EmptyData';
import TVChartContainerHook from 'components/common/TradingView/chart/TVChartContainerHook'
// import TVChartContainerHookV2 from 'components/common/TradingView/chart/TVChartContainerHookV2';
import Efficiency from 'components/StockAnalysis/components/BoxListChart/Momentum/Efficiency';
import { compareValue, formatMoney } from 'Helpers/helpFunction';
import useA from 'hook/useA';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { setShowBaocao } from 'store/actionReducers/InvestmentPortfolioStore';
import { changeTabActive, setShowModal } from 'store/actionReducers/StocksAnalysisStore';
import baocao from '../../../../assets/images/StockAnalysis/bao-cao.png'
import iconBack from '../../../../assets/images/StockAnalysis/icon-back.png'

export default function FooterPortfolio() {
  const dispatch = useDispatch();
  const InvestmentPortfolioStore = useSelector((state: any) => state?.InvestmentPortfolioStore)
  const AStore = useSelector((state: any) => state?.AStore)
  const { compareDataGrowthOverview, compareDataOverview, valueMathZero } = useA();
  const data = compareDataGrowthOverview(AStore?.GrowthOverview)
  const dataOverview = compareDataOverview(AStore?.Overview, AStore?.IcbOverviewV4)
  const [Path, setPath] = useState('')
  const StocksAnalysisStore = useSelector((state: any) => state?.StocksAnalysisStore);
  const ReportStore = useSelector((state: any) => state?.ReportStore);

  useEffect(() => {
    setPath('')
  }, [StocksAnalysisStore?.inputSearch])

  useEffect(() => {
    setTimeout(() => {
      setPath(ReportStore?.reportAnalysis?.path)
    }, 300)
  }, [ReportStore?.reportAnalysis?.path])

  const eps = AStore?.Overview?.eps ? parseFloat(AStore?.Overview?.eps).toFixed(2) : 0
  const peg = AStore?.Overview?.peg ? parseFloat(AStore?.Overview?.peg).toFixed(2) : 0
  const totalAssetsGrowth = AStore?.Overview?.totalAssetsGrowth ? formatMoney(AStore?.Overview?.totalAssetsGrowth, 2) : 0
  const paidInCapitalGrowth = AStore?.Overview?.paidInCapitalGrowth ? formatMoney(AStore?.Overview?.paidInCapitalGrowth, 2) : 0
  const valueGrowthRanking = AStore?.Overview?.growthRanking ? Object.keys(AStore?.Overview?.growthRanking)?.[0] : ''
  const valueRanking = AStore?.Overview?.valueRanking ? Object.keys(AStore?.Overview?.valueRanking)?.[0] : ''
  const valueMomentum = AStore?.Overview?.momentum ? Object.keys(AStore?.Overview?.momentum)?.[0] : ''
  const colorGrowthRanking = AStore?.Overview?.growthRanking ? compareValue(Object.keys(AStore?.Overview?.growthRanking)?.[0]) : '#ffffff'
  const colorRanking = AStore?.Overview?.valueRanking ? compareValue(Object.keys(AStore?.Overview?.valueRanking)?.[0]) : '#ffffff'
  const colorMomentum = AStore?.Overview?.momentum ? compareValue(Object.keys(AStore?.Overview?.momentum)?.[0]) : '#ffffff'

  const tangtruongvalue = [
    {
      title: valueGrowthRanking,
      title_box: 'Tăng trưởng',
      page: 'tang-truong',
      color: colorGrowthRanking,
      list: [
        {
          title: 'Tăng trưởng <br /> doanh thu thuần', value: `${data?.netsale_value?.[0]}%`,
          color: valueMathZero(data?.netsale_value?.[0])
        },
        {
          title: 'Tăng trưởng <br /> lợi nhuận thuần', value: `${data?.net_profit_value?.[0]}%`,
          color: valueMathZero(data?.net_profit_value?.[0])
        },
        {
          title: 'Tăng trưởng <br /> vốn chủ sở hữu', value: `${data?.equity_value?.[0]}%`,
          color: valueMathZero(data?.equity_value?.[0])
        },
        {
          title: 'Tăng trưởng <br /> tổng tài sản', value: `${totalAssetsGrowth}%`,
          color: valueMathZero(totalAssetsGrowth)
        },
        {
          title: 'Tăng trưởng <br /> vốn điều lệ', value: `${paidInCapitalGrowth}%`,
          color: valueMathZero(paidInCapitalGrowth)
        },
      ]
    },
    {
      title: valueRanking,
      title_box: 'Giá trị',
      page: 'gia-tri',
      color: colorRanking,
      list: [
        {
          title: ' P/E', value: `${dataOverview?.pe_value?.[0]}`,
          color: valueMathZero(dataOverview?.pe_value?.[0])
        },
        {
          title: 'P/B', value: `${dataOverview?.pb_value?.[0]}`,
          color: valueMathZero(dataOverview?.pb_value?.[0])
        },
        {
          title: 'EV/ EBITDA', value: `${dataOverview?.evEbitda_value?.[0]}`,
          color: valueMathZero(dataOverview?.evEbitda_value?.[0])
        },
      ]
    },
    {
      title: valueMomentum,
      title_box: 'Động lượng',
      page: 'dong-luong',
      color: colorMomentum,
      list: [
      ]
    }
  ];

  const handleShowModal = (path: any) => {
    dispatch(setShowModal())
    dispatch(changeTabActive({ tabActive: path }))
  }

  const handleBack = () => {
    dispatch(setShowBaocao(false))
  }

  return (
    <>
      {
        InvestmentPortfolioStore?.showBaocao ?
          <>
            <div className='JoomIJhsI0'>
              <div className='iocoyhcxbz'>
                <div className='obnyceiwqx'>Báo cáo</div>
                <div className='fbrkusvzmx'>
                  <div className='klPybDJriH' onClick={() => handleBack()}><img src={iconBack} alt='' className='SaKCuJJtHX' /></div>
                </div>
              </div>
              {Path ? <iframe src={`${Path}#toolbar=0&embedded=true&view=FitH`}
                className="djswaxczby"
                style={{ display: 'block', width: '100%', height: '100%' }}
                frameBorder="0"
                scrolling="no">
              </iframe> : <div className='drnxsggvdj'>
                <EmptyData />
              </div>}
            </div>
          </> : <>
            <div className='kbvrogihlm'>
              <TVChartContainerHook height={392} />
            </div>
            <div className='fokefupwhb'>
              {
                tangtruongvalue.map((item2, key) => {
                  return (
                    <div className='qykkxekfnk' key={key}>
                      <div className='nzpmbglsei'>
                        {item2?.title_box}:<span className='hmftlfkrwj' style={{ color: item2.color }}>{item2?.title}</span>
                      </div>
                      {
                        key < 2 ? <>
                          <div className='mzruskzglb'>
                            <div className='xaflvhlvpn'>
                              {
                                item2.list.map((item3, key3) => {
                                  return (
                                    <div className='vhgqrvwdcy' key={key3}>
                                      <div className='tlpsspwzeq' dangerouslySetInnerHTML={{ __html: item3.title }}></div>
                                      <div className='jcitkbyqdr' style={{ color: item3.color }}>{item3.value}</div>
                                    </div>
                                  )
                                })
                              }
                            </div>
                          </div>
                        </> : null
                      }
                      {
                        key === 2 ? <>
                          <div className='jiqkghiqbd'>
                            <Efficiency marginBottom='21px' />
                          </div>
                        </> : null
                      }
                      <div className='jjqxnlhqly' onClick={() => handleShowModal(item2?.page)}>Xem thêm</div>
                    </div>
                  )
                })
              }
            </div>
          </>
      }
    </>
  )
}